import React, { memo, useContext, useState } from "react";
import { TextsContext } from '../context/textsContext';
import { Icon } from "@iconify/react";
import Navbar from "react-bootstrap/Navbar";
import Button from 'react-bootstrap/Button';
import Picture from "./PictureComponent";
import StepComponents from "./StepComponents";
import { TitleH6Component } from "./TitleH6Component";
import StyleHeader from "../scss/header.module.scss";
import StyleTxt from "../scss/text.module.scss";
import * as rdd from 'react-device-detect';
import Stylegeneral from "../scss/general.module.scss";
import { useCotizador } from "../context/apiContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/userContext";
import Stylebnt from "../scss/btn.module.scss";
import { Fragment } from "react";
import StepAppComponents from "./application/StepAppComponents";
import DialogComponent from "./DialogComponent";
import { TitleH3Component } from "./TitleH3Component";
import { TitleH1Component } from "./TitleH1Component";
const MenuComponent = memo((props) => {
	const { texts, updateTexts } = useContext(TextsContext);
	const [modalCerrar, setModalCerrar] = useState(false);
	const handleClose = () => setModalCerrar(false);
	const { name, resetData } = useCotizador();
	rdd.isMobile = true;
	const { sethamburger, hamburger, menuHome, menuLogin, phase = "cotizador" } = props;
	const navigate = useNavigate();
	const reset = () => {
		resetData();
		navigate("/step1");
	}

	const { logout } = useAuth();
	const handleLogout = () => {
		logout();
		navigate('/login')
	}

	const changehamburger = () => {
		sethamburger(!hamburger);
	};


	return (
		<Fragment>
			<Navbar expand="lg" className={StyleHeader.navbarExpandLg}>
				<div className={`${StyleHeader.wMenuTitle}`} >
					<Navbar.Collapse id="navbarScroll" className={`d-lg-flex flex-lg-wrap ${StyleHeader.fDirection}`}>
						<Navbar className="p-0 ms-4 mt-0 w-100">
							<TitleH6Component styleGroup={`${StyleTxt.titlesMenu} raleway_bold fw_700 lh_30 color_secundary mb-0`}>
								{texts?.menu_greeting ?? 'Welcome back!'}
							</TitleH6Component>
						</Navbar>
						<Navbar className="mx-4 p-0 w-100 d-flex justify-content-between align-items-center">
							<div className="pe-2 d-flex align-items-center">
								<Icon icon="cil:smile" width={36} height={36} className={`pe-2 ${StyleHeader.bigIcon}`} />
								<TitleH6Component styleGroup={`${StyleTxt.titlesMenu} raleway fw_400 lh_30 color-white mb-0`}>
									{name} {texts?.menu_title ?? 'VIP Care'}
								</TitleH6Component>
							</div>

						</Navbar>
						{menuLogin ? null : <Navbar className="pt-3 pb-2 w-100">
							<Button onClick={reset} className={`raleway fw_700 color_primary bg_gray_3 mb-0 mx-3 px-2 w-100 ${StyleTxt.p}`}>
								<Icon icon="ei:plus" width={28} height={28} className={`pe-1 ${StyleHeader.bigIcon}`} />
								{texts?.menu_phrase ?? 'Start over with quote'}
							</Button>
						</Navbar>}
						<Navbar className={` d-none d-lg-block w-100 ${Stylegeneral.borderList}`}>
							{
								phase === "cotizador" ? <StepComponents /> : <StepAppComponents />
							}
						</Navbar>
						{menuHome || menuLogin ? <div className="mx-4 d-flex flex-wrap justify-content-between align-items-center w-100">
							<Navbar.Toggle aria-controls="navbarScroll" onClick={() => changehamburger()} className={`border-0  p-0`}>

								<div className='d-flex align-items-center  mt-3' >
									<div className={StyleHeader.iconidioma}>
										<Icon icon={'twemoji:flag-spain'} />
									</div>
									<span role='button' className={Stylebnt.bntIdioma} onClick={() => { updateTexts('es') }}>Español</span>
								</div>
							</Navbar.Toggle>

							<Navbar.Toggle aria-controls="navbarScroll" onClick={() => changehamburger()} className={`border-0 p-0`}>

								<div className='d-flex align-items-center  mt-3'>
									<div className={StyleHeader.iconidioma}>
										<Icon icon={'twemoji:flag-england'} />
									</div>
									<span role='button' className={Stylebnt.bntIdioma} onClick={() => { updateTexts('en') }}>English</span>

								</div>
							</Navbar.Toggle>

							<Navbar.Toggle aria-controls="navbarScroll" onClick={() => changehamburger()} className={`border-0 p-0`}>

								<div className='d-flex align-items-center  mt-3'>
									<div className={StyleHeader.iconidioma}>
										<Icon icon={'twemoji:flag-portugal'} />
									</div>
									<span role='button' className={Stylebnt.bntIdioma} onClick={() => { updateTexts('pt') }}>Português</span>
								</div>
							</Navbar.Toggle>
						</div> : null}
					</Navbar.Collapse>

				</div>

			</Navbar>

			<DialogComponent
				show={modalCerrar}
				onClose={handleClose}
				onCancel={handleClose}
				onConfirm={handleLogout}
				cancelText={texts?.general_cancel_button ?? 'Cancel'}
				confirmText={
					<span className="d-flex justify-content-center align-items-center">
						<span className="me-2 d-flex"><Icon icon='mdi:logout' width={24} height={24} /></span>
						<span>{texts?.menu_logout ?? 'Cerrar sesión'}</span>
					</span>
				}
			>
				<Icon icon='mdi:logout' width={32} height={32} className="color_primary_2 mb-3" />
				<TitleH1Component styleGroup={`raleway fw_700 color_primary_2 mb-2`}>
					{texts?.menu_logout ?? 'Cerrar sesión'}
				</TitleH1Component>
				<TitleH3Component styleGroup={`raleway py-0 mb-0 color_primary_2 fw_700`}>
					{texts?.menu_logout_phrase ?? '¿Estás seguro que deseas cerrar sesión?'}
				</TitleH3Component>
			</DialogComponent>


		</Fragment>
	);
});

export default MenuComponent;
